import { MaxViewPage } from 'tools/Uniform'
import { readableError } from 'utils/error'

// import { isRouteErrorResponse, useRouteError } from 'react-router'
const isRouteErrorResponse = () => false
const useRouteError = () => <></>

////////////////////////////////////////////////////////////////////////////////
export default function ErrorBoundary() {
  let error = useRouteError()
  return (
    <div className="base-body">
      <MaxViewPage>
        <h1 className="mb4">Oh No!</h1>
        <VisualizeError content={error} />
      </MaxViewPage>
    </div>
  )
}

export function VisualizeError({ content }) {
  if (isRouteErrorResponse(content)) {
    return (
      <>
        <p>{content.statusText}</p>
        <p>
          {content.data} ({content.status})
        </p>
      </>
    )
  } else if (content instanceof Error) {
    // console.error("Stack Trace", {content})
    return <p>{readableError(content)}</p>
  } else {
    console.error({ 'Unknown Error': content })
    return <i>Unknown error (see logs)</i>
  }
}
